// extracted by mini-css-extract-plugin
export default {"TaskLogGrid":"TaskLogGridGroup_TaskLogGrid__6Gx5B","gridOverlay":"TaskLogGridGroup_gridOverlay__xivjo","taskModal":"TaskLogGridGroup_taskModal__-3mE9"};